import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-pull-quote.css.lit';

/**
 * The SePullQuote component
 * @element se-pull-quote
 */
@customElement('se-pull-quote')
export class SePullQuote extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Attribution text
   */
  @property({ type: String })
  credit: string;

  render(): TemplateResult {
    return html`
      <div class="se-pull-quote">
        <div class="se-pull-quote--content">
          <span class="se-pull-quote--quote">
            <outline-icon
              name="quote"
              library="system"
              color="brand-secondary-1"
              size="32px"
            >
            </outline-icon>
            <slot name="quote-text"></slot>
          </span>
          ${this.credit
            ? html`<span class="se-pull-quote--attribution"
                >-&nbsp;${this.credit}</span
              >`
            : null}
        </div>
      </div>
    `;
  }
}
